export default "__VITE_ASSET__C6tz0S2Q__"